import { queryOptions } from "@tanstack/react-query";
import type { z } from "zod";
import { GetCurrentUserContract } from "./GetCurrentUserContract";
import { getCommonFetchHeaders } from "@/common/getCommonFetchHeaders";
import { HttpStatus } from "@/common/contracts";

export function getCurrentUserQueryOptionsKey() {
	return [GetCurrentUserContract.path] as const;
}

export function getCurrentUserQueryOptions(
	search: z.infer<typeof GetCurrentUserContract.search> = {},
) {
	return queryOptions({
		queryKey: getCurrentUserQueryOptionsKey(),
		queryFn: async () => {
			return fetch(
				`${import.meta.env.VITE_API_URL}/api${GetCurrentUserContract.serializePath(
					{},
					search,
				)}`,
				{
					headers: await getCommonFetchHeaders(),
				},
			).then(async (res) => {
				const result = GetCurrentUserContract.response.parse({
					status: res.status,
					body: await res.json(),
				});
				if (result.status === HttpStatus.Success) {
					return result.body;
				}
				throw new Error(result.body.message);
			});
		},
	});
}
